import { useEffect, useState } from "react";
import { MessageSquareText, Save, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";
import { Field } from "./Shared";
import { api, formatApiError } from "../lib/api";

export default function SmsSettings() {
  const [form, setForm] = useState({ account_sid: "", auth_token: "", from_number: "", enabled: true });
  const [meta, setMeta] = useState({});
  const [testTo, setTestTo] = useState("");
  useEffect(() => {
    api.get("/company/sms").then((r) => {
      setMeta(r.data);
      if (r.data.configured) setForm((f) => ({ ...f, account_sid: r.data.account_sid, from_number: r.data.from_number, enabled: r.data.enabled }));
    });
  }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async () => {
    try {
      const { data } = await api.put("/company/sms", form);
      setMeta(data);
      setForm((f) => ({ ...f, auth_token: "" }));
      toast.success("Configuration SMS enregistrée");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  const test = async () => {
    try {
      await api.post("/company/sms/test", { to: testTo });
      toast.success("SMS de test envoyé");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <div className="mt-6 rounded-xl border border-slate-200 bg-white p-6" data-testid="sms-settings">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2"><MessageSquareText className="h-4 w-4 text-teal-600" /><h3 className="text-base font-semibold text-slate-900">SMS clients (Twilio)</h3></div>
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${meta.configured ? "bg-teal-50 text-teal-700" : "bg-slate-100 text-slate-500"}`} data-testid="sms-status">{meta.configured ? "Configuré" : "Non configuré — e-mail uniquement"}</span>
      </div>
      <p className="mt-1 text-xs text-slate-500">Quand l'équipe appuie sur « En route » dans Nomade, le client reçoit son heure d'arrivée estimée par e-mail et, si configuré, par SMS. Identifiants disponibles sur console.twilio.com (chiffrés chez nous).</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <Field label="Account SID"><Input data-testid="sms-sid-input" value={form.account_sid} onChange={set("account_sid")} placeholder="AC…" /></Field>
        <Field label="Auth Token"><Input type="password" autoComplete="new-password" data-testid="sms-token-input" value={form.auth_token} onChange={set("auth_token")} placeholder={meta.has_auth_token ? "•••••••• (enregistré — laisser vide pour conserver)" : ""} /></Field>
        <Field label="Numéro d'envoi Twilio"><Input data-testid="sms-from-input" value={form.from_number} onChange={set("from_number")} placeholder="+33…" /></Field>
        <label className="flex items-center gap-2 self-end pb-2 text-sm text-slate-700"><Switch data-testid="sms-enabled-switch" checked={form.enabled} onCheckedChange={(v) => setForm({ ...form, enabled: v })} />Envoyer les SMS</label>
      </div>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-end">
        <Button data-testid="sms-save-button" className="bg-[#0b2c6b]" onClick={save}><Save className="mr-2 h-4 w-4" />Enregistrer</Button>
        {meta.configured && (
          <>
            <Field label="Tester vers"><Input data-testid="sms-test-input" value={testTo} onChange={(e) => setTestTo(e.target.value)} placeholder="06 12 34 56 78" /></Field>
            <Button variant="outline" data-testid="sms-test-button" onClick={test}><Send className="mr-2 h-4 w-4" />Envoyer un test</Button>
          </>
        )}
      </div>
    </div>
  );
}
